<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>Out of Sight</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent">By K.C. Wells</p>
<p class="P_Normal__And__Left_Indent">Second Sight: Book Three</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Detective Gary Mitchell and psychic Dan Porter have a new cold case to tackle, and new leads to research in the hunt for Gary’s brother’s killer. Their life in Boston has settled into a comfortable rhythm.</p>
<p class="P_Normal">But when forensic discoveries in a recent robbery gone wrong share similarities with their three-year-old cold case, all they can do is follow the evidence—and Dan’s gift—which leads them in an unexpected direction, way out of their comfort zone.</p>
<p class="P_Normal">Gary and Dan find themselves in a shadowy world where they can trust no one, with unseen opponents who want them to back away from their investigation—and suddenly they’re in a race they have to win.</p>
<p class="P_Normal">Because if they don’t, the consequences could be more far-reaching than they could possibly imagine.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?ec6386de